// extracted by mini-css-extract-plugin
export default {"root":"single_change_item-module___root___b3536bfa","change":"single_change_item-module___change___b5ef44e8"};